@if (subscription) {
  <div class="card card-nb h-100">
    <div class="card-body pb-0">
      <div class="row">
        <div class="col"><h2>{{'subscription_support_headline' | i18next}}</h2></div>
      </div>
      <div class="row">
        @if (subscription.hasSupport) {
          <div class="col">
            {{'subscription_has_premium_support' | i18next}}
          </div>
        }
        @if (!subscription.hasSupport) {
          <div class="col">
            {{'subscription_has_basic_support' | i18next}}
          </div>
        }
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-end align-items-center">
        <a href="https://pascom.net/forum/" class="mt-3" target="_blank">
          <span class="mr-2">{{'subscription_open_forum' | i18next}}</span>
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
        </a>
        @if (subscription.hasSupport) {
          <a
            href="tel:{{ dialableSupportNumber }}" class="btn btn-outline-primary ml-3 mt-3">
            {{ 'support_contact_support_number' | i18next: { number: supportNumber} }}
          </a>
        }
        @if (subscription.hasSupport) {
          <a [routerLink]="['/supportV2/ticket/create', subscription.appliance_id]"
            class="btn btn-outline-primary ml-3 mt-3">
            {{'support_ticket_add_button' | i18next}}
          </a>
        }
      </div>
    </div>
  </div>
}
